import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Topbar.module.scss";
const TopbarBase = ({ brand, nav, actions, glass = false, className, ...rest }) => {
    return (_jsxs("header", { className: cn(styles.topbar, glass && styles.glass, className), ...rest, children: [_jsx("div", { className: styles.section, children: brand }), nav && _jsx("div", { className: styles.section, children: nav }), _jsx("div", { className: cn(styles.section, styles.sectionEnd), children: actions })] }));
};
const TopbarNav = ({ className, ...rest }) => _jsx("nav", { className: cn(styles.nav, className), ...rest });
export const Topbar = TopbarBase;
Topbar.Nav = TopbarNav;
